import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Instagram, Linkedin } from 'lucide-react';
import newLogo from '../assets/images/new-logo.png';

const InvestorsPage = () => {
  useEffect(() => {
    document.title = "Artie - Investors";
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-neutral-900">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-neutral-100">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" onClick={() => ReactGA.event({ category: "Navigation", action: "Home", label: "Logo" })} className="flex items-center gap-2 group">
            <img src={newLogo} alt="Artie" className="w-40 h-40 object-contain" />
          </Link>
          <Link to="/" onClick={() => ReactGA.event({ category: "Navigation", action: "Home", label: "Back to Home" })} className="text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors font-geist">
            Back to Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 font-geist">Investors</h1>
        
        <div className="space-y-12 font-geist text-neutral-800 leading-relaxed mt-12">
          
          <section>
            <p className="text-xl text-neutral-600 mb-8 font-geist leading-relaxed">
              Artie is building the commercial infrastructure for independent creators.
            </p>
            <p className="text-lg text-neutral-600 mb-8 font-geist leading-relaxed">
              We’re interested in connecting with investors who understand creators, media, data, and long-term platform value.
            </p>
          </section>

          <section className="pt-8 border-t border-neutral-100">
            <h2 className="text-2xl font-bold mb-6 text-neutral-900">Contact Us</h2>
            <p>
              To get in touch, please email Matt McDonald at <a href="mailto:matt@artie.co" className="text-neutral-900 font-medium underline underline-offset-2 hover:text-neutral-600">matt@artie.co</a>.
            </p>
          </section>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white pt-12 pb-12 border-t border-neutral-200 mt-auto">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
             <div className="flex gap-4">
              <a href="https://www.instagram.com/officialartieco?igsh=ZWQyYXNwNG8zN3lr" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-neutral-900 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/artieco/" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-neutral-900 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
            <p className="text-sm text-neutral-400 font-geist">
              © 2026 Artie. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default InvestorsPage;